module.exports = __webpack_public_path__ + "media/images/theme/default/favicon-749a0d6fe0a9806d62d45e137e5650d9.ico";